import styled, {css} from "styled-components";
import React, {useState} from "react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {useParams} from "react-router-dom";
import {orderDel} from "../../api/order";

const ContentFrame = styled.div`
width: 100%;
display: flex;
flex-direction: column;
gap: 80px;
@media (max-width: 767px) {
  gap: 36px;
}
`;

const InfoFrame = styled.div`
width: 100%;
border: 1px solid #99a5ac;
border-radius: 8px;
background-color: #f3f7fd;
display: flex;
flex-direction: column;
`;

const InfoTopFrame = styled.div`
width: 100%;
border-bottom: solid 1px #ddd;
padding: 30px;
display: flex;
flex-direction: column;
gap: 10px;
@media (max-width: 1099px) {
  padding: 20px;
}
`;

const InfoBottomFrame = styled.div`
width: 100%;
padding: 20px 30px;
display: flex;

align-items: center;
@media (max-width: 1099px) {
  padding: 12px 20px;
}
`;

const InfoTitle = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #222;
text-align: left;
@media (max-width: 1099px) {
  font-size: 16px;
}
`;

const InfoContents = styled.div`
font-family: Gongim-Reguler;
font-size: 18px;
color: #707070;
line-height: 160%;
text-align: left;
@media (max-width: 1099px) {
  font-size: 14px;
}
`;
const CheckClickFrame = styled.div`
display: flex;
gap: 10px;
align-items: center;
`;

const CheckOffFrame = styled.div`
width: 24px;
height: 24px;
background-color: #d9d9d9;
border-radius: 99px;
border: solid 1px #aaaaaa;
@media (max-width: 1099px) {
  width: 18px;
  height: 18px;
}
`;


const CheckOnFrame = styled.img`
width: 24px;
@media (max-width: 1099px) {
  width: 18px;
}
`;

const CheckText = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #707070;
@media (max-width: 1099px) {
  font-size: 16px;
}
`;


const SubContentFrame = styled.div`
display: flex;
flex-direction: column;
gap: 30px;
@media (max-width: 1099px) {
  gap: 10px;
}
`;
const SubTitleFrame = styled.div`
display: flex;
justify-content: space-between;
`;
const SubTitle = styled.div`
font-family: Gongim-Medium;
font-size: 32px;
@media (max-width: 1099px) {
  font-size: 18px;
}
`;
const CallFrame = styled.div`
border-radius: 99px;
padding-right: 20px;
height: 42px;
background-color: #349dec;
display: flex;
justify-content: start;
align-items: center;
gap: 8px;
@media (max-width: 1099px) {
  height: 26px;
  gap: 3px;
  padding-right: 10px;
  margin-top: -2px;
}
`;

const CallText = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #fff;
@media (max-width: 1099px) {
  font-size: 15px;
}
`;
const CallText02 = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #fff;
@media (max-width: 1099px) {
  display: none;
}
`;

const Call = styled.img`
height: 100%;
`;

const TableFrame = styled.div`
width: 100%;
display: flex;
flex-direction: column;
border-top: solid 2px #99a5ac;
box-sizing: content-box;
`;

const TableRow = styled.div`
width: 100%;
border-bottom: solid 2px #ddd;
box-sizing: content-box;
padding: 28px 0;
display: flex;
justify-content: start;
gap: 80px;

@media (max-width: 767px) {
  border-bottom: none;
  flex-direction: column;
  padding: 0;
  gap: 0px;
}
`;
const TableGroup = styled.div`
width: 510px;
display: flex;
justify-content: start;
align-items: center;
@media (max-width: 1099px) {
  width: 100%;
}
@media (max-width: 767px) {
  padding: 28px 0;
  border-bottom: solid 2px #ddd;
}
`;

const TableLeftTitle = styled.div`
width: 150px;
font-family: Gongim-Medium;
font-size: 20px;
text-align: left;
color: #333;
${(props) =>
    props.vali ?
      css`
    color: #EB3F3D;
  ` :
      css`
    color: #333;
  `
  }
@media (max-width: 1099px) {
  width: 104px;

  font-size: 16px;
}
`;

const RadioFrame = styled.div`
display: flex;
gap: 40px;
@media (max-width: 767px) {
  flex-direction: column;
  gap: 16px;
}
`;

const RadioContentFrame = styled.div`
display: flex;
align-items: center;
gap: 10px;
`;

const RadioOn = styled.div`
width: 24px;
height: 24px;
background-color: #fff;
border: 6px solid #585858;
border-radius: 99px;
@media (max-width: 1099px) {
  width: 16px;
  height: 16px;
  border: 4px solid #585858;
}
`;

const RadioOff = styled.div`
width: 24px;
height: 24px;
background-color: #d9d9d9;
border: 1px solid #aaa;
border-radius: 99px;
@media (max-width: 1099px) {
  width: 16px;
  height: 16px;
}
`;

const RadioText = styled.div`
font-family: Gongim-Reguler;
font-size: 18px;
color: #707070;
@media (max-width: 1099px) {
  font-size: 15px;
}
`;

const TextInfut = styled.input`
width: 260px;
height: 40px;
padding: 0 20px;
border: 1px solid #707070;
color: #333;
font-family: Gongim-Medium;
font-size: 16px;
${(props) =>
    props.vali === true ?
      css`
    border: 1px solid #EB3F3D;
    color: #EB3F3D;
  ` :
      css`
    border: 1px solid #707070;
    color: #333;
  `
  }
@media (max-width: 1099px) {
  border-radius: 0;
  height: 36px;
  flex: 1;
  font-size: 14px;
  padding: 0 12px;
}
`;

const CarImg = styled.img`
width: 22px;
@media (max-width: 1099px) {
  width: 18px;
}
`;

const ButtonLine = styled.div`
width: 100%;
display: flex;
justify-content: center;
gap: 20px;
padding: 0 0 80px 0;
@media (max-width: 1099px) {
  gap: 10px;
  padding: 36px 0;
  padding-top: 0;
}
`;

const ButtonRed = styled.div`
width: 230px;
height: 50px;
border-radius: 4px;
display: flex;
justify-content: center;
align-items: center;
background-color: #eb3f3d;
color: #fff;
font-family: Gongim-Medium;
font-size: 20px;
cursor: pointer;
@media (max-width: 1099px) {
  flex: 1;
  height: 40px;
  font-size: 18px;
}
`;

const ButtonBack = styled.div`
width: 230px;
height: 50px;
border-radius: 4px;
border: 1px solid #707070;
display: flex;
justify-content: center;
align-items: center;
background-color: #fff;
color: #707070;
font-family: Gongim-Medium;
font-size: 20px;
cursor: pointer;
@media (max-width: 1099px) {
  flex: 1;
  height: 40px;
  font-size: 18px;
}
`;
const RightRowFrame = styled.div`
  display: flex;

  flex: 1;
`;
const RightMedium = styled.div`
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const RightReguler = styled.div`
  font-family: Gongim-Reguler;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const RightColFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;
const PayTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 28px;
  }
`;
const RedTitle = styled.div`
  font-family: Gongim-Reguler;
  font-size: 16px;
  color: #eb3f3d;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 12px;
  }
`;
const WordSkip = styled.div`
  @media (min-width: 1100px) {
    display: none;
  }
`;
const RightMedium86px = styled.div`
  width: 86px;
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 15px;
    width: 72px;
  }
`;
const RightColFrameMini = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const RightRegulerMini = styled.div`
  font-family: Gongim-Reguler;
  font-size: 16px;
  color: #707070;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 12px;
  }
`;





export default function Content01(payLoad) {
  const [sendAddrDialogOpen, setSendAddrDialogOpen] = useState(false);
  const [endAddrDialogOpen, setEndAddrDialogOpen] = useState(false);
  const [payload, setPayload] = useState(payLoad.payload);
  const { orderNo } = useParams();

  // const remark = payload.remark.split(" ");
  // const defaultPrice = Number(remark[1].split(":")[1].split(",")[0]);
  // const emergency = Number(remark[2].split(":")[1].split(",")[0]);
  // const outBack = Number(remark[3].split(":")[1].split(",")[0]);
  // const danger = Number(remark[4].split(":")[1].split(",")[0]);
  const replacePrice = (str) => {
    const comma = (str) => {
      str = String(str);
      return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
    };
    const uncomma = (str) => {
      str = String(str);
      return str.replace(/[^\d]+/g, "");
    };
    return comma(uncomma(str));
  }
  const replacePhoneNo = (str) => {
    str = String(str)
    return str.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  }

  const orderCancel = () => {
    const req = {
      orderNo: orderNo,
      refTransNo: '',
      transNo: '',
      cancelType: '1',
      cancelComment: ''
    }

    orderDel(req).then(res => {
      window.location.replace(`/driveloc/${orderNo}`);
    }).catch(err => {
      alert(err.data.message);
      window.location.replace('/*');
      console.log(err);
    })
  }

  const sendDialogClose = () => {
    setSendAddrDialogOpen(false);
  };
  const endDialogClose = () => {
    setEndAddrDialogOpen(false);
  };

  return (
    <ContentFrame>
      <InfoFrame style={{ backgroundColor: "#fff", border: "0" }}>
        <InfoTitle style={{ fontSize: "18px" }}>주문을 접수 했습니다.</InfoTitle><br />
        <InfoContents style={{ color: "#707070", fontSize: "16px" }}>
          기사님을 배차중이며, 배차가 완료되면 <br /> 다시 안내 드리겠습니다.
        </InfoContents>
      </InfoFrame>
      <SubContentFrame>
        <SubTitleFrame>
          <SubTitle>주문 접수</SubTitle>
        </SubTitleFrame>
        <TableFrame>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>이동 유형</TableLeftTitle>
              <RightRowFrame>
                {payload.assignType === 1 &&
                  <RightMedium>차량 가져오기 (픽업)</RightMedium>
                }
                {payload.assignType === 3 &&
                  <RightMedium>차량 보내기 (딜리버리)</RightMedium>
                }
                {payload.assignType === 2 &&
                  <RightMedium>왕복 (픽업&딜리버리)</RightMedium>
                }
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>전화번호</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{replacePhoneNo(payload.user.phoneNo)}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>차량정보</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{payload.routes[0].car.brand} {payload.routes[0].car.vehicleModel} {payload.routes[0].car.carNo}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
        </TableFrame>
      </SubContentFrame>
      {(payload.assignType === 1 || payload.assignType === 2) &&
        <SubContentFrame>
          <SubTitleFrame>
            <SubTitle>차량 가져오기 (픽업)</SubTitle>
          </SubTitleFrame>
          <TableFrame>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>출발지</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.routes[0].addr} ({payload.routes[0].addrDetail})</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>도착지</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.routes[1].addr} ({payload.routes[1].addrDetail})</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>날짜/시간</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.reservationDate.split(" ")[0].split("-")[0]}년 {payload.reservationDate.split(" ")[0].split("-")[1]}월 {payload.reservationDate.split(" ")[0].split("-")[2]}일 {payload.reservationDate.split(" ")[1].split(".")[0]}</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
          </TableFrame>
        </SubContentFrame>
      }
      {(payload.assignType === 3 || payload.assignType === 2) &&
        <SubContentFrame>
          <SubTitleFrame>
            <SubTitle>차량 보내기 (딜리버리)</SubTitle>
          </SubTitleFrame>
          <TableFrame>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>출발지</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.routes[0].addr} ({payload.routes[0].addrDetail})</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>도착지</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.routes[1].addr} ({payload.routes[1].addrDetail})</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
            <TableRow>
              <TableGroup style={{ width: "auto" }}>
                <TableLeftTitle>날짜/시간</TableLeftTitle>
                <RightRowFrame>
                  <RightMedium>{payload.reservationDate.split(" ")[0].split("-")[0]}년 {payload.reservationDate.split(" ")[0].split("-")[1]}월 {payload.reservationDate.split(" ")[0].split("-")[2]}일 {payload.reservationDate.split(" ")[1].split(".")[0]}</RightMedium>
                </RightRowFrame>
              </TableGroup>
            </TableRow>
          </TableFrame>
        </SubContentFrame>
      }
      <SubContentFrame>
        <SubTitleFrame>
          <SubTitle>결제 및 특이사항</SubTitle>
        </SubTitleFrame>
        <TableFrame>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>운행 거리</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{payload.distance}KM</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>요금</TableLeftTitle>
              <RightColFrame>
                <RightRowFrame style={{ gap: "10px", alignItems: "flex-end" }}>
                  <RightMedium>총 결제 금액</RightMedium>
                  <RightRowFrame style={{ alignItems: "flex-end" }}>
                    <PayTitle style={{ marginBottom: "-5px" }}>
                      {replacePrice(payload.payAmount)}
                      {/*{payload.routes[0].car.brand === '외산' ?*/}
                      {/*  (defaultPrice + emergency + outBack + danger ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :*/}
                      {/*  (defaultPrice + emergency + outBack + danger ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')*/}
                      {/*}*/}
                    </PayTitle>
                    <RightMedium>원</RightMedium>
                  </RightRowFrame>
                </RightRowFrame>
                <RedTitle>
                  대기/경유/취소/부가업무 발생시
                  <br /> 추가 요금이 발생 될 수 있습니다.
                </RedTitle>
              </RightColFrame>
            </TableGroup>
          </TableRow>

          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>특이사항</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{payload.extMemo1}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
        </TableFrame>
      </SubContentFrame>
      <ButtonLine>
        <ButtonRed onClick={() => { setSendAddrDialogOpen(true) }}>호출 취소</ButtonRed>
      </ButtonLine>
      <Dialog
        open={sendAddrDialogOpen}
        onClose={sendDialogClose}
      >
        <DialogContent style={{ width: "320px", height: "auto", padding: "16px", gap: "16px" }}>
          <InfoTitle style={{ fontSize: "14px", padding: "32px 0" }}>도착지 까지 신속하게 모실 기사님을 찾고 있는 중 입니다. 정말로 호출을 취소 하시겠습니까?</InfoTitle>
          <ButtonLine style={{ padding: "0" }}>
            <ButtonBack onClick={() => { sendDialogClose() }}>아니요</ButtonBack>
            <ButtonRed onClick={() => { orderCancel() }}>호출취소</ButtonRed>
          </ButtonLine>
        </DialogContent>
      </Dialog>
    </ContentFrame>
  )
}


/*
  픽업&딜리버리 오더를 받는다 -> 가격 영수증을 받고 픽업값 + 딜리버리값 을 통해 총 금액을 보여준다.
  알림톡 또는 sms 로 픽업오더 따로 딜리버리 오더 따로 알림톡을 받게 된다.
  그럴경우 픽업 알림톡에는 픽업에 관한 가격이 나와야하고 딜리버리 알림톡에는 딜리버리에 관한 가격이 나오게된다.
  그러면 2000원은 어떻게 추가시키지???
  흐으으으음
  여기서 2000원을 추가시키는 이유는 수입산 자동차는 2000원 수수료가 붙는다
*/

// <TableGroup>
//   <TableLeftTitle>
//     요금 <WordSkip />
//     상세내역
//   </TableLeftTitle>
//   <RightColFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         기본 요금
//       </RightMedium86px>
//       <RightReguler>원</RightReguler>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         긴급 배차
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>원</RightReguler>
//         <RightRegulerMini>
//           접수시간 기준 3시간 이내 배차 요청
//         </RightRegulerMini>
//       </RightColFrameMini>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         오지 요금
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>원</RightReguler>
//         <RightRegulerMini>
//           출발지/도착지가 읍/면/리일 경우
//         </RightRegulerMini>
//       </RightColFrameMini>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         배차
//         <br />
//         취약시간
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>원</RightReguler>
//         <RightRegulerMini>
//           출발시간 기준 16:00 ~ 09:00
//         </RightRegulerMini>
{/*      </RightColFrameMini>*/}
{/*    </RightRowFrame>*/}
{/*  </RightColFrame>*/}
{/*</TableGroup>*/}